import { FC, ReactNode } from 'react'
import { AntTagColor, Progress } from '@agro-club/agroclub-shared'
import { CollapseHeaderWrapper, TitleAndTagWrapper } from 'views/pages/LogisticsKR/LogisticRequests/components/styled'
import { BoardCounter } from 'views/components/Board/BoardCounter'

type Props = {
  counter: number | undefined
  progress: Progress
  tagColor?: AntTagColor
  title: ReactNode
}

export const TripOffersHeader: FC<Props> = ({ counter, progress, tagColor = 'orange', title }) => {
  return (
    <CollapseHeaderWrapper>
      <TitleAndTagWrapper>
        <div>{title}</div>
        <BoardCounter counter={counter} progress={progress} color={tagColor} />
      </TitleAndTagWrapper>
    </CollapseHeaderWrapper>
  )
}
